import http from './http'

export default {
  getSyllabusInfo: () => http.get('syllabus-info'),
}
